import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Button from '@material-ui/core/Button';
import { Container, Typography, MenuItem, Hidden, TextField, Divider, Link, FormHelperText, Tooltip } from '@material-ui/core';
import { genfunction } from '../../../helpers';
import ReactHtmlParser from 'react-html-parser';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Moment from 'moment';
import Select from '@material-ui/core/Select';

import {
    actionUpdateMembershipPackage, actionDeleteMembershipTypePerson, actionUpdateMembershipAddonsQuantity,
    actionUpdateFamilyMemberNotPartOfPackage, actionResetCustomerAddresses, actionResetMembershipPackage, actionResetCustomer,
    actionGetMembershipUserDefinedFields, actionUpdateMembershipUdfsWithCustomerUdfsValues, actionResetMembershipUDFs,
    actionResetCustomerUdfs, actionResetMemberValidation, actionShopCartAddMembershipPackage, actionGetCountryAndState,
    actionSetFieldValueState, actionResetFieldValuesState, actionUpdateUdfsOnEditCancel, actionStartAppLoader, actionEndAppLoader,
    actionUpdateMemberTypeUDfsOnSave
} from 'actions';

import { useDispatch, useSelector } from 'react-redux';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';
import { FormControl } from '@material-ui/core';
import DialogeBox from '../../../components/DialogeBox/DialogeBox';
import Checkbox from '@material-ui/core/Checkbox';
import MaskedInput from 'react-text-mask';
import MembershipUDF from '../../../components/UDFs/MembershipUDF';
import { Autocomplete } from '@material-ui/lab';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';


const { AddPersonFirstNameLength, AddPersonLastNameLength, AddPersonEmailLength, AddPersonDOBLength, AddPersonZipCodeLength, AddPersonCityLength,
    PhoneNumberMandatory, AddPersonAddress1Length, AddPersonAddress2Length, DOBRegex, EmailRegex, ValidateMembershipMinQuantity,
    TryDeletePrimaryRecordOnMembership, ConfirmMsgRemovePersonFromMemberPackage, DisplayMemPackageDiscriptionCharacters, PackageDiscriptionHeading,
    ValidateMembershipMaxQuantity, PackageMaxQtyMsg, PackageMinQtyMsg, OrderItemsInCartError, MembershipAddOnsHeading
} = window['runConfig'];


const useStyles = makeStyles(theme => ({
    root: {
        //padding: theme.spacing(3)
    },
    primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    mainHeading: {
        //padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        minHeight: '40px',
        maxHeight: '70px'
    },
    dialogTitleHeader: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '50px'
    },
    smalltourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        minHeight: '25px',
        maxHeight: '60px'
    },
    hr: {
        display: 'block',
        height: '1px',
        border: 0,
        borderTop: '1px solid #ccc',
        padding: 0
    },
    displaynone: {
        display: "none"
    },
    visible: {
        visibility: "visible"
    },
    box100per: {
        width: "100%"
    },
    AddHoverOnIcons: {
        cursor: "pointer !important"
    },
    tablecell: {
        padding: "5px"
    },
    errorColor: {
        color: 'red !mportant'
    },
    defaultColor: {
        color: theme.palette.text.secondary
    },
    udfWidth: {

        minWidth: 300,

    },
    clearButton: {
        "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
            color: theme.palette.primary.main

        }
    },
    NoPersonAssignedTxt: {
        fontSize: "16px",
        marginLeft: "15px",
        marginTop: "2px",
        fontSize: "14px",

        [theme.breakpoints.down('sm')]: {
            marginLeft: "5px",
            fontSize: "12px",
        }
    },
    UserNameDisplay: {
        fontSize: "16px",
        marginLeft: "15px",

        [theme.breakpoints.down('sm')]: {
            marginLeft: "5px",
            fontSize: "12px",
        }
    }

}));

function TextMaskCustom(props) {
    const { inputRef, onChange, value, ...other } = props;
    let pnMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return (
        <MaskedInput
            value={value}
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            onChange={onChange}
            mask={pnMask}
        />
    );
}

export default function MembershipTypes(props) {

    let memberPackage;
    let usersnotpartofpackage;
    const dispatch = useDispatch();


    const membershippackagesreducer = useSelector(state => state.reducerMembershipPackages);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    memberPackage = membershippackagesreducer.membershipPackage;
    usersnotpartofpackage = membershippackagesreducer.familymembersnotpartofPackage;
    const membermemberhisps = useSelector(state => state.reducerMemberMemberships);
    const memberValidationReducer = useSelector(state => state.reducerMemberValidation);
    const [isredirectclicked, setisredirectclicked] = useState(false);
    const memmemberhisps = useSelector(state => state.reducerMemberMemberships);
    const customer = useSelector(state => state.reducerCustomer);
    const membershipTypesUdfs = useSelector(state => state.reducerMembershipUserDefinedFields);
    const customerUdfs = useSelector(state => state.reducerCustomerUDFs);
    const shopcartMembershipPackage = useSelector(state => state.reducerShopCart.MembershipPackages);
    const countryandstates = useSelector(state => state.reducerCountryAndState.countryandstate);



    //Intialize States
    const [errorstate, seterrorstate] = React.useState({
        initialerrorstate: {
            first_name: {
                errorstate: false,
                errortext: ""
            },
            last_name: {
                errorstate: false,
                errortext: ""
            },
            email: {
                errorstate: false,
                errortext: ""
            },
            membershipType: {
                errorstate: false,
                errortext: ""
            },
            age: {
                errorstate: false,
                errortext: ""
            },
            phone: {
                errorstate: false,
                errortext: ""
            },
            address1: {
                errorstate: false,
                errortext: ""
            },
            city: {
                errorstate: false,
                errortext: ""
            },
            state: {
                errorstate: false,
                errortext: ""
            },
            zipcode: {
                errorstate: false,
                errortext: ""
            },
            country: {
                errorstate: false,
                errortext: ""
            }
        }
    });

    const filterOptions = createFilterOptions({
        stringify: (option) => option.Country + '' + option.State,
    });

    const [state, setState] = React.useState({
        memberpackageDetail: {
            popupTitle: 'Add Person',
            isPrimaryMember: false,
            firstName: '',
            lastName: '',
            email: '',
            dob: null,
            phone: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipcode: '',
            country: '',
            membershipPackageID: props.membershipPackage.hasOwnProperty("MembershipPackageID") ? props.membershipPackage.MembershipPackageID : 0,
            membershipTypeID: 0,
            membershipTypeName: '',
            isRenewal: false,
            userNo: props.isRenewPackage ? 0 : Math.floor((Math.random() * 100000) + 100000),// when its renew package, userno field will be 0, assign value when we select from dropdown or create new.
            isEdit: false,
            UniquePackageRef: '',
            MembershipExpiryDate: '',
            PreviousMembershipType: '',
            notPartOfPackage: false
        }
    });

    window.history.pushState({ name: "browserBack" }, "on browser back click", window.location.href);

    useEffect(() => {
        // Prompt confirmation when reload page is triggered
        window.onbeforeunload = () => { return "" };

        // Unmount the window.onbeforeunload event
        return () => { window.onbeforeunload = null };
    }, []);


    // useEffect(() => {

    //     if (props.isRenewPackage && usersnotpartofpackage && usersnotpartofpackage.length == 0) {
    //         setopenMembership(true);
    //     }

    // }, [props.isRenewPackage])

    // useEffect(() => {

    // }, [props.isRenewPackage])

    useEffect(() => {
        actionGetCountryAndState(dispatch);
    }, [])

    const onChangeCountry = (event, value) => {
        var memberpackageDetail = { ...state.memberpackageDetail };

        memberpackageDetail.country = (value === null ? '' : value.Country);
        setState({ ...state, memberpackageDetail: memberpackageDetail })
        actionSetFieldValueState(dispatch, "country", memberpackageDetail.country);

        memberpackageDetail.state = "";
        setState({ ...state, memberpackageDetail: memberpackageDetail });
        actionSetFieldValueState(dispatch, "state", "");
    }
    const onChangeState = (event, value) => {
        var memberpackageDetail = { ...state.memberpackageDetail };

        memberpackageDetail.state = value === null ? "" : value.State
        setState({ ...state, memberpackageDetail: memberpackageDetail });
        actionSetFieldValueState(dispatch, "state", memberpackageDetail.state);
    }

    const isShowCountryFields = (columnName) => {
        return genfunction.GetValueFromCountryAndState(countryandstates, state.memberpackageDetail.country, columnName);
    }

    const handleCloseMembership = () => {
        var memberpackageDetail = { ...state.memberpackageDetail };

        if (memberpackageDetail.isPrimaryMember && !memberpackageDetail.isEdit) {

            props.history.push({
                pathname: '/memberships'
            })
        }
        else {
            setOpen(false);
        }
    };

    const AssignPrimaryMembershipTypeInDropDownToPimaryMember = (memberpackageDetail) => {
        if (membershippackagesreducer.membershippackages && membershippackagesreducer.membershippackages.length > 0) {

            if (membershippackagesreducer.membershippackages.filter(x => x.MembershipPackageID === props.membershipPackageID).length > 0) {
                var membershipPackage = membershippackagesreducer.membershippackages.find(x => x.MembershipPackageID === props.membershipPackageID);

                if (membershipPackage && membershipPackage.MembershipProducts && membershipPackage.MembershipProducts.length > 0) {
                    var primaryMemType = membershipPackage.MembershipProducts.find(x => x.MembershipType === "Membership");

                    memberpackageDetail.membershipTypeName = replaceEscapeCharacters(primaryMemType.ProductName);
                    memberpackageDetail.membershipTypeID = primaryMemType.MembershipTypeID;
                }
            }
        }
    }

    useEffect(() => {

        if (!props.shopcartmember) {
            handleClickOpen();
            var memberpackageDetail = { ...state.memberpackageDetail };
            memberpackageDetail.isPrimaryMember = true;
            memberpackageDetail.popupTitle = "Primary Member";

            AssignPrimaryMembershipTypeInDropDownToPimaryMember(memberpackageDetail);

            memberpackageDetail.country = countryandstates && countryandstates.length > 0 ? countryandstates[0].Country : '';
            setState({ ...state, memberpackageDetail: memberpackageDetail })
        }
        else {
            actionUpdateMembershipPackage(dispatch, props.membershipPackage, true);
            memberPackage = props.membershipPackage;
        }


        if (props.isRenewPackage) {

            props.membershipPackage.MembershipProducts && props.membershipPackage.MembershipProducts.map(e => {

                if (e.MembershipType === "Membership" && e.Users !== undefined && e.Users.length > 0) {

                    e.Users.map(u => {
                        if (u.isPrimaryMember) {
                            actionSetFieldValueState(dispatch, "first_name", u.firstName === undefined ? '' : u.firstName);
                            actionSetFieldValueState(dispatch, "last_name", u.lastName === undefined ? '' : u.lastName);
                            actionSetFieldValueState(dispatch, "email", u.email === undefined ? '' : u.email);
                            actionSetFieldValueState(dispatch, "phone_number", u.phone === undefined ? '' : u.phone);
                            actionSetFieldValueState(dispatch, "address1", u.address1 === undefined ? '' : u.address1);
                            actionSetFieldValueState(dispatch, "address2", u.address2 === undefined ? '' : u.address2);
                            actionSetFieldValueState(dispatch, "city", u.city === undefined ? '' : u.city);
                            actionSetFieldValueState(dispatch, "state", u.state === undefined ? '' : u.state);
                            actionSetFieldValueState(dispatch, "zip", u.zipcode === undefined ? '' : u.zipcode);
                            actionSetFieldValueState(dispatch, "country", u.country === undefined ? '' : u.country);

                        }
                    });
                }
            });
        }

    }, []);

    useEffect(() => {

        if (props.membershipTypeIDs && props.membershipTypeIDs.length > 0 && membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length < 1) {

            if (props.isRenewPackage) {
                actionStartAppLoader(dispatch);
            }

            actionGetMembershipUserDefinedFields(dispatch, 'Memberships', null, props.membershipTypeIDs);
        }

    }, [props.membershipTypeIDs]);

    useEffect(() => {
        if (props.isRenewPackage) {
            if (membershipTypesUdfs.updateMemberRecordsOnRenew === false && customerUdfs.customerUDFs && customerUdfs.customerUDFs.length > 0 && membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0 && CountTotalMembers() > 0) {

                setTimeout(() => {
                    actionUpdateMembershipUdfsWithCustomerUdfsValues(dispatch, props.membershipPackage, customerUdfs.customerUDFs);
                }, 1000);
            }
            else if (customerUdfs.customerUDFs && customerUdfs.customerUDFs.length > 0 && !ValidateCustomerUdfs(customerUdfs.customerUDFs)) {
                actionEndAppLoader(dispatch);
            }
            else if (ValidateCustomerUdfs(customerUdfs.customerUDFs) && membershipTypesUdfs.membershipUdfs.length == 0) {
                actionEndAppLoader(dispatch);
            }

            if (membershipTypesUdfs.updateMemberRecordsOnRenew === true) {
                actionEndAppLoader(dispatch);
            }
        }

    }, [customerUdfs.customerUDFs, membershipTypesUdfs.updateMemberRecordsOnRenew, membershipTypesUdfs.membershipUdfs]);


    const ValidateCustomerUdfs = (cstUdfs) => {
        let valid = false;

        if (cstUdfs[0].CustomerUDFs.filter(x => x.UDFValue !== null).length > 0) {

            cstUdfs[0].CustomerUDFs.filter(x => x.UDFValue !== null && x.UDFValue !== '0.0000' && x.UDFValue !== '0').map(udf => {
                valid = true;
            });
        }

        return valid;
    }

    //Dialog Fields Start
    const [open, setOpen] = React.useState(false);

    //Dialog Membership  Start
    const [openMembership, setopenMembership] = React.useState(false);

    //Confirmation Dialog
    const [confirmopen, setconfirmOpen] = React.useState({
        dialogBox: false,
        packageID: 0,
        memTypeID: 0,
        useNo: 0,
        deletemsg: ''
    });


    const handleClickOpen = (memID, memTypeName) => {

        var memberpackageDetail = { ...state.memberpackageDetail };

        memberpackageDetail.popupTitle = 'Add Person';
        memberpackageDetail.isPrimaryMember = false;
        memberpackageDetail.firstName = '';
        memberpackageDetail.lastName = '';
        memberpackageDetail.email = '';
        memberpackageDetail.dob = 'DOB';
        memberpackageDetail.phone = '';
        memberpackageDetail.address1 = '';
        memberpackageDetail.address2 = '';
        memberpackageDetail.city = '';
        memberpackageDetail.state = '';
        memberpackageDetail.zipcode = '';
        memberpackageDetail.country = '';
        memberpackageDetail.MembershipPackageID = props.membershipPackage.hasOwnProperty("MembershipPackageID") ? props.membershipPackage.MembershipPackageID : 0;
        memberpackageDetail.membershipTypeID = memID === undefined ? 0 : memID;
        memberpackageDetail.membershipTypeName = memTypeName === undefined ? '' : memTypeName;
        memberpackageDetail.PreviousMembershipType = '';
        memberpackageDetail.isEdit = false;
        memberpackageDetail.isRenewal = false;
        memberpackageDetail.userNo = Math.floor((Math.random() * 100000) + 100000); //0;
        memberpackageDetail.MembershipTypeID = 0;
        memberpackageDetail.notPartOfPackage = false;

        setState({ ...state, memberpackageDetail: memberpackageDetail })

        var initialerrorstate = { ...errorstate.initialerrorstate };

        initialerrorstate.first_name.errorstate = false;
        initialerrorstate.first_name.errortext = "";
        initialerrorstate.last_name.errorstate = false;
        initialerrorstate.last_name.errortext = "";
        initialerrorstate.email.errorstate = false;
        initialerrorstate.email.errortext = "";
        initialerrorstate.membershipType.errorstate = false;
        initialerrorstate.membershipType.errortext = "";
        initialerrorstate.age.errorstate = false;
        initialerrorstate.age.errortext = "";
        // initialerrorstate.userNo.errorstate = false;
        // initialerrorstate.userNo.errortext = "";


        seterrorstate({ ...errorstate, initialerrorstate });

        setOpen(true);

    };

    //Create New Profile
    const [createNewProfile, setCreateNewProfile] = React.useState(false);

    useEffect(() => {

        var memberpackageDetail = { ...state.memberpackageDetail };
        if (memberpackageDetail && !memberpackageDetail.isEdit &&
            memberpackageDetail.membershipTypeID < 1
            && props.membershipPackage
            && (memberpackageDetail.popupTitle === 'Add Person' || memberpackageDetail.popupTitle === 'Add - Person' || memberpackageDetail.popupTitle === 'Primary Member')) {

            if (props.membershipPackage.MembershipProducts
                && props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").length == 1) {
                let membershipObj = props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership")[0];
                fieldhandleChange(null, membershipObj);
            }
        }

    }, [props.membershipPackage, state])

    const handleClose = (event, reason) => {

        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            setOpen(true);
        }
        else {

            var memberpackageDetail = { ...state.memberpackageDetail };
            if (memberpackageDetail.isPrimaryMember && !memberpackageDetail.isEdit) {

                if (shopcartMembershipPackage && shopcartMembershipPackage.length < 1 &&
                    membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {

                    actionResetMembershipUDFs(dispatch);
                }

                actionResetMembershipPackage(dispatch);

                props.history.push({
                    pathname: '/memberships'
                })
            }
            else {

                if (memberpackageDetail.isPrimaryMember && memberpackageDetail.isEdit) {
                    SetPrimaryMemberRecordOnCheckout(memberpackageDetail);

                }

                if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0 && memberpackageDetail.isEdit) {
                    actionUpdateUdfsOnEditCancel(dispatch, memberpackageDetail.membershipTypeID, memberpackageDetail.userNo, true);
                }

                setOpen(false);
                setCreateNewProfile(false);
            }
        }
    };

    const GetUserDOB = (user) => {
        let userDOB = "";

        if (user.hasOwnProperty('dob') && user.dob !== null && user.dob.length > 0 && user.dob != "DOB") {
            userDOB = Moment(user.dob).format('YYYY-MM-DD');
        }

        return userDOB;
    }
    //Edit Person
    const EditPerson = (member, memTypeID) => {

        var memberpackageDetail = { ...state.memberpackageDetail };
        var membershipType = memberPackage.MembershipProducts.filter(x => x.MembershipTypeID == memTypeID)[0];

        if (membershipType) {
            var user = membershipType.Users.filter(x => x.userNo == member.userNo && x.email == member.email)[0];
            if (user) {
                memberpackageDetail.popupTitle = user.isPrimaryMember ? 'Edit - Primary Member' : 'Edit - Person';
                memberpackageDetail.isPrimaryMember = user.isPrimaryMember;
                memberpackageDetail.firstName = user.firstName;
                memberpackageDetail.lastName = user.lastName;
                memberpackageDetail.email = user.email;
                memberpackageDetail.dob = GetUserDOB(user);
                memberpackageDetail.phone = user.phone;
                memberpackageDetail.address1 = user.address1;
                memberpackageDetail.address2 = user.address2;
                memberpackageDetail.city = user.city;
                memberpackageDetail.state = user.state;
                memberpackageDetail.zipcode = user.zipcode;
                memberpackageDetail.country = user.country;
                memberpackageDetail.isRenewal = user.isRenewal;
                memberpackageDetail.UniquePackageRef = user.UniquePackageRef;
                memberpackageDetail.MembershipExpiryDate = user.MembershipExpiryDate;
                memberpackageDetail.MembershipPackageID = memberPackage.MembershipPackageID;
                memberpackageDetail.membershipTypeID = membershipType.MembershipTypeID;
                memberpackageDetail.membershipTypeName = replaceEscapeCharacters(membershipType.ProductName);
                memberpackageDetail.PreviousMembershipType = user.PreviousMembershipType;
                memberpackageDetail.userNo = user.userNo;
                memberpackageDetail.isEdit = true;
                memberpackageDetail.notPartOfPackage = user.notPartOfPackage;

            }
        }

        setState({ ...state, memberpackageDetail: memberpackageDetail })

        setOpen(true);
    }

    //Delete Person
    const DeletePerson = (memberTypeID, member) => {

        if (member.isPrimaryMember) {
            seterrorMsg(TryDeletePrimaryRecordOnMembership);
        }
        else {

            setconfirmOpen({
                dialogBox: true, packageID: memberPackage.MembershipPackageID,
                memTypeID: memberTypeID, useNo: member.userNo,
                deletemsg: ConfirmMsgRemovePersonFromMemberPackage + ' ' + member.firstName + ' ' + member.lastName + '?'
            });
        }
    }

    const ConfirmDeletePerson = () => {
        var deleteConfirmState = { ...confirmopen };
        actionDeleteMembershipTypePerson(dispatch, deleteConfirmState.packageID, deleteConfirmState.memTypeID, deleteConfirmState.useNo);


        if (usersnotpartofpackage && usersnotpartofpackage.length > 0 && usersnotpartofpackage.filter(x => x.userNo == deleteConfirmState.useNo && x.membershipTypeID == 0
            && x.MembershipExpiryDate == '').length > 0) {
            actionUpdateFamilyMemberNotPartOfPackage(dispatch, deleteConfirmState.useNo, false);
        }

        setconfirmOpen({
            dialogBox: false, packageID: 0,
            memTypeID: 0, useNo: 0, deletemsg: ''
        });

        //On Renew, if we want to delete user selected from drop down, we need to reset back so, it will be available again in dropdown.


    }

    const CancelPersonDelete = () => {

        setconfirmOpen({
            dialogBox: false, packageID: 0,
            memTypeID: 0, useNo: 0, deletemsg: ''
        });
    }

    function validateEmail(email) {
        var re = new RegExp(EmailRegex);
        return re.test(String(email).toLowerCase());
    }

    function validateDOB(dob) {
        var re = new RegExp(DOBRegex);
        let resultRegex = re.test(String(dob).toLowerCase());
        if (resultRegex) {
            let isValidRange = Moment(dob).isBetween(Moment('1899-12-31'), Moment());
            return isValidRange;
        }
        else
            return resultRegex;
    }

    //Enable Confirm Buttom
    const [confirmBtn, setconfirmBtn] = React.useState(true);

    const ValidateMemberPackageQuantities = () => {
        let validRequest = false;

        if (memberPackage && memberPackage.MembershipProducts && memberPackage.MembershipProducts.length > 0) {
            memberPackage.MembershipProducts = memberPackage.MembershipProducts.map(memType => {

                if (memType.MembershipType === "Membership" && (((memType.Users !== undefined && memType.Users.length) < memType.MinQuantity) || ((memType.Users !== undefined && memType.Users.length) > memType.MaxQuantity))) {
                    validRequest = true;
                }

                if (memType.MembershipType === "AddOn") {
                    if (((memType.Quantity < memType.MinQuantity) || (memType.Quantity > memType.MaxQuantity))) {
                        validRequest = true;
                    }
                }

                return memType;
            });
        }

        return validRequest;
    }

    const PersonNamesDuplicateCheck = (membership) => {

        let exist = false;
        if (memberPackage && memberPackage.MembershipProducts && membership.isEdit == false) {
            memberPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").map(m => {

                if (m.Users && m.Users.length > 0 && m.Users.filter(x => x.firstName.toLowerCase() == membership.firstName.toLowerCase() && x.lastName.toLowerCase() == membership.lastName.toLowerCase()).length > 0) {
                    exist = true;
                }
            })
        }

        return exist;
    }

    const SetPrimaryMemberRecordOnCheckout = (member) => {

        if (member && memberPackage.MembershipProducts && memberPackage.MembershipProducts.length > 0) {
            var membershipType = memberPackage.MembershipProducts.filter(x => x.MembershipTypeID == member.membershipTypeID)[0];

            if (membershipType) {
                var user = membershipType.Users.filter(x => x.userNo == member.userNo)[0];

                if (user) {

                    actionSetFieldValueState(dispatch, "first_name", user.firstName);
                    actionSetFieldValueState(dispatch, "last_name", user.lastName);
                    actionSetFieldValueState(dispatch, "email", user.email);
                    actionSetFieldValueState(dispatch, "phone_number", user.phone);
                    actionSetFieldValueState(dispatch, "address1", user.address1);
                    actionSetFieldValueState(dispatch, "address2", user.address2);
                    actionSetFieldValueState(dispatch, "city", user.city);
                    actionSetFieldValueState(dispatch, "zip", user.zipcode);
                    actionSetFieldValueState(dispatch, "state", user.state);
                    actionSetFieldValueState(dispatch, "country", user.country);
                }
            }
        }
    }

    //Save Button MultipleClicks
    const [saveBtn, setsaveBtn] = React.useState(false);

    const saveDialog = () => {

        setsaveBtn(true);

        setTimeout(() => {
            setsaveBtn(false);
        }, 1000)

        if (!ValidateMembershipType()) {
            seterrorMsg('Please fill the required UDFs.');
            return;
        }
        //Add Validation
        var initialerrorstate = { ...errorstate.initialerrorstate };

        if (state.memberpackageDetail.firstName.trim().length < 1) {
            initialerrorstate.first_name.errorstate = true;
            initialerrorstate.first_name.errortext = "First Name is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else {
            initialerrorstate.first_name.errorstate = false;
            initialerrorstate.first_name.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }

        if (state.memberpackageDetail.lastName.trim().length < 1) {
            initialerrorstate.last_name.errorstate = true;
            initialerrorstate.last_name.errortext = "Last Name is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        } else {
            initialerrorstate.last_name.errorstate = false;
            initialerrorstate.last_name.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }

        if (state.memberpackageDetail.membershipTypeID < 1) {
            initialerrorstate.membershipType.errorstate = true;
            initialerrorstate.membershipType.errortext = "Membership Type is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else {
            initialerrorstate.membershipType.errorstate = false;
            initialerrorstate.membershipType.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }


        if (state.memberpackageDetail.isPrimaryMember && state.memberpackageDetail.email.trim().length < 1) {
            initialerrorstate.email.errorstate = true;
            initialerrorstate.email.errortext = "Email  is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else if (state.memberpackageDetail.email.length > 0 && validateEmail(state.memberpackageDetail.email) == false) {
            initialerrorstate.email.errorstate = true;
            initialerrorstate.email.errortext = "Please enter a valid email address.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else {
            initialerrorstate.email.errorstate = false;
            initialerrorstate.email.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }

        if (state.memberpackageDetail.dob) {
            if (state.memberpackageDetail.dob.length > 0
                && state.memberpackageDetail.dob != "DOB"
                && validateDOB(state.memberpackageDetail.dob) == false) {

                initialerrorstate.age.errorstate = true;
                initialerrorstate.age.errortext = "Please enter a valid date of birth.";
                seterrorstate({ ...errorstate, initialerrorstate });
            }
            else {
                initialerrorstate.age.errorstate = false;
                initialerrorstate.age.errortext = "";
                seterrorstate({ ...errorstate, initialerrorstate });
            }
        }

        if (PhoneNumberMandatory && state.memberpackageDetail.phone.trim().length < 1) {
            initialerrorstate.phone.errorstate = true;
            initialerrorstate.phone.errortext = "Phone is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else {
            initialerrorstate.phone.errorstate = false;
            initialerrorstate.phone.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }


        if (state.memberpackageDetail.isPrimaryMember) {

            if (state.memberpackageDetail.address1.trim().length < 1) {
                initialerrorstate.address1.errorstate = true;
                initialerrorstate.address1.errortext = "Address 1 is required.";
                seterrorstate({ ...errorstate, initialerrorstate });
            } else {
                initialerrorstate.address1.errorstate = false;
                initialerrorstate.address1.errortext = "";
                seterrorstate({ ...errorstate, initialerrorstate });
            }

            if (state.memberpackageDetail.city.trim().length < 1) {
                initialerrorstate.city.errorstate = true;
                initialerrorstate.city.errortext = "City is required.";
                seterrorstate({ ...errorstate, initialerrorstate });
            } else {
                initialerrorstate.city.errorstate = false;
                initialerrorstate.city.errortext = "";
                seterrorstate({ ...errorstate, initialerrorstate });
            }

            if (isShowCountryFields("ShowState")) {

                if (state.memberpackageDetail.state.trim().length < 1) {
                    initialerrorstate.state.errorstate = true;
                    initialerrorstate.state.errortext = "State is required.";
                    seterrorstate({ ...errorstate, initialerrorstate });
                } else {
                    initialerrorstate.state.errorstate = false;
                    initialerrorstate.state.errortext = "";
                    seterrorstate({ ...errorstate, initialerrorstate });
                }
            }
            else {
                state.memberpackageDetail.state = "0";
            }

            if (isShowCountryFields("ShowPostalCode")) {
                if (state.memberpackageDetail.zipcode.trim().length < 1) {
                    initialerrorstate.zipcode.errorstate = true;
                    initialerrorstate.zipcode.errortext = "Zipcode is required.";
                    seterrorstate({ ...errorstate, initialerrorstate });
                } else {
                    initialerrorstate.zipcode.errorstate = false;
                    initialerrorstate.zipcode.errortext = "";
                    seterrorstate({ ...errorstate, initialerrorstate });
                }
            }
            else {
                state.memberpackageDetail.zipcode = "0";
            }

            if (state.memberpackageDetail.country.trim().length < 1) {
                initialerrorstate.country.errorstate = true;
                initialerrorstate.country.errortext = "Country is required.";
                seterrorstate({ ...errorstate, initialerrorstate });
            } else {
                initialerrorstate.country.errorstate = false;
                initialerrorstate.country.errortext = "";
                seterrorstate({ ...errorstate, initialerrorstate });
            }
        }

        if (initialerrorstate.first_name.errorstate || initialerrorstate.last_name.errorstate || initialerrorstate.membershipType.errorstate || initialerrorstate.email.errorstate || initialerrorstate.age.errorstate ||
            initialerrorstate.address1.errorstate || initialerrorstate.city.errorstate || initialerrorstate.state.errorstate || initialerrorstate.zipcode.errorstate || initialerrorstate.country.errorstate
            || (PhoneNumberMandatory && initialerrorstate.phone.errorstate)) {
            setOpen(true);
        }
        else {
            var ageDiff = parseInt(calculateAge(new Date(state.memberpackageDetail.dob)));

            var memType = memberPackage.MembershipProducts.filter(x => x.MembershipTypeID == state.memberpackageDetail.membershipTypeID)[0];

            if (memType.AgeBasedMembership && (ageDiff < memType.MinAge || ageDiff > memType.MaxAge)) {
                initialerrorstate.age.errorstate = true;
                initialerrorstate.age.errortext = "Please enter a valid DOB, Min Age is " + memType.MinAge + " and Max Age is : " + memType.MaxAge;
                seterrorstate({ ...errorstate, initialerrorstate });
            }
            else {
                if (PersonNamesDuplicateCheck(state.memberpackageDetail) == false) {
                    actionUpdateMembershipPackage(dispatch, state.memberpackageDetail, false);

                    if (state.memberpackageDetail.notPartOfPackage) {
                        actionUpdateFamilyMemberNotPartOfPackage(dispatch, state.memberpackageDetail.userNo, true);
                    }

                    setOpen(false);
                }
                else {
                    seterrorMsg('First Name and Last Name is already used.');
                }
            }
        }

        if (props.isRenewPackage && state.memberpackageDetail.isEdit === false && createNewProfile === false && usersnotpartofpackage) {

            if (usersnotpartofpackage && usersnotpartofpackage.length > 0 && usersnotpartofpackage.filter(x => x.notpartofPackage == true && x.userSelectedFromDropdown === false).length > 0) {

                usersnotpartofpackage = usersnotpartofpackage.map(user => {

                    if (user.userNo === state.memberpackageDetail.userNo) {
                        user.userSelectedFromDropdown = true;
                    }
                });

            }
        }

        if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {
            var memberpackageDetail = { ...state.memberpackageDetail };

            if (memberpackageDetail.isEdit) {
                actionUpdateMemberTypeUDfsOnSave(dispatch, memberpackageDetail.membershipTypeID, memberpackageDetail.userNo);
            }
        }

        setCreateNewProfile(false);
    }

    const fieldhandleChange = (event, mem) => {

        var memberpackageDetail = { ...state.memberpackageDetail };

        if (event && event.currentTarget && !event.currentTarget.dataset.hasOwnProperty('userid')) {

            if (mem) {
                let memTypeID = parseInt(mem.MembershipTypeID);
                memberpackageDetail.membershipTypeID = memTypeID;
                memberpackageDetail.membershipTypeName = mem.ProductName;

                setState({ ...state, memberpackageDetail: memberpackageDetail })
            }
        }

        if (event && event.target.name === "fname") {
            memberpackageDetail.firstName = event.target.value;
            memberpackageDetail.MembershipPackageID = props.membershipPackage.hasOwnProperty("MembershipPackageID") ? props.membershipPackage.MembershipPackageID : 0;
            setState({ ...state, memberpackageDetail: memberpackageDetail });

            if (memberpackageDetail.isPrimaryMember) {
                actionSetFieldValueState(dispatch, "first_name", event.target.value);
            }
        }

        if (event && event.target.name === "lname") {
            memberpackageDetail.lastName = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });

            if (memberpackageDetail.isPrimaryMember) {
                actionSetFieldValueState(dispatch, "last_name", event.target.value);
            }
        }

        if (event && event.target.name === "email") {
            memberpackageDetail.email = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });

            if (memberpackageDetail.isPrimaryMember) {
                actionSetFieldValueState(dispatch, "email", event.target.value);
            }
        }

        if (event && event.target.name === "dob") {
            memberpackageDetail.dob = Moment(event.target.value).format('YYYY-MM-DD');

            // if (event.nativeEvent.target.value === event.nativeEvent.target.defaultValue)
            //     memberpackageDetail.dob = "";

            setState({ ...state, memberpackageDetail: memberpackageDetail })
        }

        if (memberpackageDetail.dob === "Invalid date") {
            memberpackageDetail.dob = "";
            setState({ ...state, memberpackageDetail: memberpackageDetail })
        }

        if (event && event.target.name === "phone") {
            memberpackageDetail.phone = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });

            if (memberpackageDetail.isPrimaryMember) {
                actionSetFieldValueState(dispatch, "phone_number", event.target.value);
            }
        }

        if (event && event.target.name === "membershipType") {
            let memTypeID = parseInt(event.currentTarget.id);
            memberpackageDetail.membershipTypeID = memTypeID;
            memberpackageDetail.membershipTypeName = event.target.value;

            setState({ ...state, memberpackageDetail: memberpackageDetail })
        }

        if (event && event.target.name === "address1") {
            memberpackageDetail.address1 = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });
            actionSetFieldValueState(dispatch, "address1", event.target.value);
        }

        if (event && event.target.name === "address2") {
            memberpackageDetail.address2 = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });
            actionSetFieldValueState(dispatch, "address2", event.target.value);
        }

        if (event && event.target.name === "city") {
            memberpackageDetail.city = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });
            actionSetFieldValueState(dispatch, "city", event.target.value);
        }

        if (event && event.target.name === "zipcode") {
            memberpackageDetail.zipcode = event.target.value;
            setState({ ...state, memberpackageDetail: memberpackageDetail });
            actionSetFieldValueState(dispatch, "zip", event.target.value);
        }

        if (event && event.target.name === "searchExistingMemberProfile") {
            let userNo = parseInt(event.currentTarget.dataset.userid);
            memberpackageDetail.userNo = userNo;

            //Select User from Dropdown  UserNotPart Of Package.  usersnotpartofpackage

            if (userNo > 0 && usersnotpartofpackage && usersnotpartofpackage.length > 0 && usersnotpartofpackage.filter(x => x.notpartofPackage == true && x.userSelectedFromDropdown === false).length > 0) {
                let user = usersnotpartofpackage.filter(x => x.userNo == userNo)[0];

                if (user) {

                    memberpackageDetail.firstName = genfunction.IsNotNullOrEmptyOrUndefined(user.firstName) ? user.firstName : '';
                    memberpackageDetail.lastName = genfunction.IsNotNullOrEmptyOrUndefined(user.lastName) ? user.lastName : '';
                    memberpackageDetail.email = genfunction.IsNotNullOrEmptyOrUndefined(user.email) ? user.email : '';
                    memberpackageDetail.dob = genfunction.IsNotNullOrEmptyOrUndefined(user.dob) ? Moment(user.dob).format('YYYY-MM-DD') : '';;
                    memberpackageDetail.phone = genfunction.IsNotNullOrEmptyOrUndefined(user.phone) ? user.phone : '';
                    memberpackageDetail.PreviousMembershipType = genfunction.IsNotNullOrEmptyOrUndefined(user.PreviousMembershipType) ? user.PreviousMembershipType : undefined;
                    memberpackageDetail.MembershipExpiryDate = genfunction.IsNotNullOrEmptyOrUndefined(user.MembershipExpiryDate) ? user.MembershipExpiryDate : undefined;

                }

                if (createNewProfile) {
                    setCreateNewProfile(false);
                }
            }

            setState({ ...state, memberpackageDetail: memberpackageDetail });
        }
    };

    //Error Handling Start
    const [errorMsg, seterrorMsg] = React.useState('');

    const errorcancelhandle = () => {
        seterrorMsg('');
    }

    //Error Handling Start


    const changeQuantityHandler = (memberType) => {
        //Check Min and Max Quantity
        //need to add
        memberType.MembershipPackageID = memberPackage.MembershipPackageID;
        actionUpdateMembershipAddonsQuantity(dispatch, memberType);
    }

    const ValidatePrimaryMemberRecord = () => {

        let error = "";

        if (memberPackage && memberPackage.MembershipProducts && memberPackage.MembershipProducts.length > 0) {
            memberPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").map(memType => {

                if (memType.Users && memType.Users.length > 0 && memType.Users.filter(x => x.isPrimaryMember === true).length > 0 && error.length == "") {

                    let priUser = memType.Users.filter(x => x.isPrimaryMember === true)[0];

                    if (priUser) {

                        if (!genfunction.IsNotNullOrEmptyOrUndefined(priUser.firstName)) {
                            return error = 'Primary Member First Name is required.';
                        }

                        if (!genfunction.IsNotNullOrEmptyOrUndefined(priUser.lastName)) {
                            return error = 'Primary Member Last Name is required.';
                        }

                        if (!genfunction.IsNotNullOrEmptyOrUndefined(priUser.email)) {
                            return error = 'Primary Member Email is required.';
                        }

                        if (!genfunction.IsNotNullOrEmptyOrUndefined(priUser.phone) && PhoneNumberMandatory === true) {
                            return error = 'Primary Member phone is required.';
                        }

                        if (!genfunction.IsNotNullOrEmptyOrUndefined(priUser.address1)) {
                            return error = 'Primary Member Address 1 is required.';
                        }

                        if (!genfunction.IsNotNullOrEmptyOrUndefined(priUser.city)) {
                            return error = 'Primary Member City is required.';
                        }

                        if (!genfunction.IsNotNullOrEmptyOrUndefined(priUser.state)) {
                            return error = 'Primary Member State is required.';
                        }

                        if (!genfunction.IsNotNullOrEmptyOrUndefined(priUser.zipcode)) {
                            return error = 'Primary Member Zipcode is required.';
                        }
                    }
                }
            });
        }

        return error;
    }

    const ConfirmMembershipPackage = () => {

        if (orderProducts && orderProducts.length > 0) {
            seterrorMsg(OrderItemsInCartError);
            return;
        }

        if (props.isRenewPackage) {
            let err = ValidateMembersUDFs();
            if (err && err.length > 0) {
                seterrorMsg(err);
                return;
            }

            err = ValidatePrimaryMemberRecord();
            if (err && err.length > 0) {
                seterrorMsg(err);
                return;
            }
        }

        if (CountTotalMembers() > memberPackage.MaximumMembersInPackage) {
            seterrorMsg(PackageMaxQtyMsg + memberPackage.MaximumMembersInPackage);
        }
        else if (CountTotalMembers() < memberPackage.MinimumMembersInPackage) {
            seterrorMsg(PackageMinQtyMsg + memberPackage.MinimumMembersInPackage + ' membership(s).');
        }
        else {
            actionShopCartAddMembershipPackage(dispatch, memberPackage, props.isRenewPackage);
            props.constnextredirect();
        }
    }

    const CountTotalMembers = () => {

        let totalMembers = 0;

        if (memberPackage) {
            memberPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").map(m => {

                if (m.Users && m.Users.length > 0) {

                    totalMembers += m.Users.length;
                }
            });
        }

        return totalMembers;
    }

    function calculateAge(birthday) { // birthday is a date
        var ageDifMs = Date.now() - birthday;
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    //Click on Cancel Membership Package
    const constredirect = () => {

        if (shopcartMembershipPackage && shopcartMembershipPackage.length < 1) {

            if (props.isRenewPackage) {
                actionResetCustomer(dispatch);
                actionResetMemberValidation(dispatch);
                actionResetCustomerUdfs(dispatch);
                actionResetCustomerAddresses(dispatch);
            }

            if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {
                actionResetMembershipUDFs(dispatch);
            }

            actionResetFieldValuesState(dispatch);
            actionResetMembershipPackage(dispatch);
        }

        props.history.push({
            pathname: '/memberships'
        })
    }

    const [showMoreInfo, setShowMoreInfo] = React.useState(false);
    const [readmorebtnText, setreadmorebtnText] = React.useState('Read More');

    const ShowMoreInfoClick = () => {

        if (readmorebtnText === 'Read More') {
            setShowMoreInfo(true);
            setreadmorebtnText('Read Less');
        }
        else {
            setShowMoreInfo(false);
            setreadmorebtnText('Read More');
        }
    }


    const GetMembershipPackageDis = (discription) => {

        if (discription) {
            if (showMoreInfo) {
                return discription.substring(0, discription.length - 1);
            }

            return discription.substring(0, DisplayMemPackageDiscriptionCharacters);
        }

        return "";
    }


    const AddReviewMemberToPackage = (user) => {

        var memberpackageDetail = { ...state.memberpackageDetail };

        if (user) {
            memberpackageDetail.popupTitle = 'Add - Person';
            memberpackageDetail.isPrimaryMember = false;
            memberpackageDetail.firstName = user.firstName;
            memberpackageDetail.lastName = user.lastName;
            memberpackageDetail.email = user.email;
            memberpackageDetail.dob = GetUserDOB(user);
            memberpackageDetail.phone = user.phone;
            memberpackageDetail.address1 = user.address1;
            memberpackageDetail.address2 = user.address2;
            memberpackageDetail.city = user.city;
            memberpackageDetail.state = user.state;
            memberpackageDetail.zipcode = user.zipcode;
            memberpackageDetail.isRenewal = user.isRenewal;
            memberpackageDetail.UniquePackageRef = user.UniquePackageRef;
            memberpackageDetail.MembershipExpiryDate = user.MembershipExpiryDate;
            memberpackageDetail.MembershipPackageID = memberPackage.MembershipPackageID;
            memberpackageDetail.membershipTypeID = 0;
            memberpackageDetail.membershipTypeName = '';
            memberpackageDetail.userNo = user.userNo;
            memberpackageDetail.isEdit = false;
            memberpackageDetail.notPartOfPackage = user.notpartofPackage;
        }


        setState({ ...state, memberpackageDetail: memberpackageDetail })

        setOpen(true);

    }

    //Membership Popup
    const BackMembershipPopup = () => {
        actionResetMemberValidation(dispatch);
        actionResetFieldValuesState(dispatch);
        setisredirectclicked(true);
    }

    useEffect(() => {

        if (isredirectclicked) {
            setisredirectclicked(false);
            let memPackID = 0;

            if (memberPackage && memberPackage.hasOwnProperty('MembershipPackageID')) {
                memPackID = memberPackage.MembershipPackageID;
            }

            props.history.push({
                pathname: '/memberships'
            })
        }

    }, [isredirectclicked]);

    // const RenewMembershp = (mp) => {

    //     //Update Primar Record

    //     if (customer.customer.length > 0) {
    //         actionSetFieldValueState(dispatch, "first_name", customer.customer[0].FirstName);
    //         actionSetFieldValueState(dispatch, "last_name", customer.customer[0].LastName);
    //         actionSetFieldValueState(dispatch, "email", customer.customer[0].GuestEmail);
    //         actionSetFieldValueState(dispatch, "phone_number", customer.customer[0].CustomerAddress[0].MobilePhone);
    //         actionSetFieldValueState(dispatch, "address1", customer.customer[0].CustomerAddress[0].Street1);
    //         actionSetFieldValueState(dispatch, "address2", customer.customer[0].CustomerAddress[0].Street2);
    //         actionSetFieldValueState(dispatch, "city", customer.customer[0].CustomerAddress[0].CitySuburb);
    //         actionSetFieldValueState(dispatch, "state", customer.customer[0].CustomerAddress[0].State);
    //         actionSetFieldValueState(dispatch, "zip", customer.customer[0].CustomerAddress[0].Postcode);
    //         actionSetFieldValueState(dispatch, "country", customer.customer[0].CustomerAddress[0].Country);
    //     }

    //     actionUpdatePackageForRenew(dispatch, mp.MembershipPackageID, memmemberhisps, customer.customer);
    //     setopenMembership(false);

    //     props.history.push({
    //         pathname: '/memberships/renew/' + mp.MembershipPackageID
    //     })
    // }

    // const renewmembershipsdistinct = () => {
    //     const renewmemshipscollection = [];

    //     membermemberhisps.membermerberhips[0].Memberships.filter(x => x.IsRenewed == false).map(x => {

    //         if (renewmemshipscollection.filter(y => y.MembershipPackageID == x.MembershipPackageID).length == 0) {
    //             renewmemshipscollection.push(x);
    //         }
    //     });

    //     return renewmemshipscollection;
    // }

    const classes = useStyles();

    //Show Fields

    let displayclass = "";
    if (state.memberpackageDetail.isPrimaryMember)
        displayclass = classes.visible;
    else
        displayclass = classes.displaynone;


    const replaceEscapeCharacters = (item) => {
        var itemValue = item.split("\\r\\n").join("<br />");
        itemValue = itemValue.split("\\").join("");
        return itemValue;
    }

    const GetMembershipTypeQty = (memPackage, memTypeProd) => {

        let availQty = '';

        if (memTypeProd) {

            if (memTypeProd.MinQuantity > 0) {
                availQty = '(Min Qty : ' + memTypeProd.MinQuantity + ', Max Qty : ' + memTypeProd.MaxQuantity + ')';
            }

            if (memTypeProd.MinQuantity < 1 || memTypeProd.MinQuantity == memTypeProd.MaxQuantity) {
                availQty = '(Max Qty : ' + memTypeProd.MaxQuantity + ')';
            }

            if (memTypeProd.MaxQuantity >= memPackage.MaximumMembersInPackage && memTypeProd.MinQuantity > 0) {
                availQty = '(Min Qty : ' + memTypeProd.MinQuantity + ')';
            }

            if (memTypeProd.MaxQuantity >= memPackage.MaximumMembersInPackage && memTypeProd.MinQuantity < 1) {
                availQty = '';
            }

            if (memTypeProd.MinQuantity == memPackage.MaximumMembersInPackage) {
                availQty = '';
            }
        }

        return availQty;
    }

    const GetDefaultMembershipName = (membershipTypeName) => {

        let memtypename = '';

        if (props.membershipPackage && props.membershipPackage.MembershipProducts)
            if (props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").length == 1) {
                memtypename = props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership")[0].ProductName;
            }
            else {
                memtypename = membershipTypeName;
            }

        return memtypename;
    }

    const GetDefaultMemberName = (memberNo) => {

        let userName = '';

        if (memberNo > 0 && usersnotpartofpackage && usersnotpartofpackage.length > 0 && usersnotpartofpackage.filter(x => x.notpartofPackage == true).length > 0) {
            let user = usersnotpartofpackage.filter(x => x.userNo == memberNo)[0];

            if (user) {
                userName = user.firstName + ' ' + user.lastName;
            }
        }

        return userName;
    }

    const ValidateMembershipType = () => {
        let valid = true;
        var memberpackageDetail = { ...state.memberpackageDetail };

        if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0 && membershipTypesUdfs.membershipUdfs.filter(x => x.MembershipTypeID == memberpackageDetail.membershipTypeID).length > 0) {

            membershipTypesUdfs.membershipUdfs.filter(x => x.MembershipTypeID == memberpackageDetail.membershipTypeID).filter(x => x.UDFCategories).map(udfCategorey => {

                if (udfCategorey.UDFCategories && udfCategorey.UDFCategories.length > 0 && valid) {

                    udfCategorey.UDFCategories.map(udfCate => {
                        udfCate.UserDefinedFields.map((udf) => {

                            if (valid) {
                                if (udf.IsRequired && udf.Users && udf.Users.length == 0) {
                                    valid = false;
                                }
                                else if (udf.IsRequired && udf.Users && udf.Users.length > 0 && udf.Users.filter(x => x.userID == memberpackageDetail.userNo).length < 1) {
                                    valid = false;
                                }
                                else if (udf.IsRequired && udf.Users && udf.Users.length > 0 && udf.Users.filter(x => x.userID == memberpackageDetail.userNo).length > 0) {
                                    let user = udf.Users.filter(x => x.userID == memberpackageDetail.userNo)[0];

                                    if (user.userUDFValue !== undefined && user.userUDFValue !== null) {

                                        if ((udf.UDFType === "Text" || udf.UDFType === "Decimal") && user.userUDFValue.length < 1) {
                                            valid = false;
                                        }
                                        else if (udf.UDFType === "Bit" && user.userUDFValue === false) {
                                            valid = false;
                                        }
                                    }
                                }
                            }
                        })
                    });
                }
            });
        }

        return valid;
    }
    const ValidateMembersUDFs = () => {

        let error = '';

        if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {

            membershipTypesUdfs.membershipUdfs.filter(x => x.UDFCategories).map(membershipType => {

                let memberusers = GetMembershipTypeUserCount(membershipType.MembershipTypeID);

                if (membershipType.UDFCategories != null && membershipType.UDFCategories.length > 0 && error.length == 0 && memberusers > 0) {

                    membershipType.UDFCategories.map((udfCategorey, i) => {

                        udfCategorey.UserDefinedFields.map((udf) => {
                            if (error.length == 0 && udf.IsRequired && udf.hasOwnProperty('Users') && udf.Users !== undefined && memberusers != udf.Users.length) {
                                error = 'Please fill the required UDFs for Membership Type ' + GetMembershipTypeName(membershipType.MembershipTypeID);
                                return;
                            }
                        })
                    });
                }
            })
        }

        return error;
    }

    const GetMembershipTypeName = (memTypeID) => {
        let memberTypeName = '';

        if (memberPackage) {
            memberTypeName = memberPackage.MembershipProducts.filter(x => x.MembershipType === "Membership" && x.MembershipTypeID == memTypeID)[0].ProductName;
        }

        return memberTypeName;
    }

    const GetMembershipTypeUserCount = (memTypeID) => {
        let totalMembers = 0;

        if (memberPackage) {
            memberPackage.MembershipProducts.filter(x => x.MembershipType === "Membership" && x.MembershipTypeID == memTypeID).map(m => {

                if (m.Users && m.Users.length > 0) {

                    totalMembers += m.Users.length;
                }
            });
        }

        return totalMembers;
    }

    const onChangeInput = (e) => {

        if (e.nativeEvent.target.defaultValue === e.nativeEvent.target.value) {

            e.nativeEvent.target.defaultValue = "";
            e.nativeEvent.target.value = "";

            setTimeout(fieldhandleChange(e), 0);

        }
    }

    return (
        <Container className={classes.root}>
            <ErrorHandling msg={errorMsg.length > 0 ? errorMsg : ''}
                open={errorMsg.length > 0 ? true : false} handleclose={errorcancelhandle} />
            <Grid container justify="center">
                <Grid item lg={12} sm={12} xs={12} align="center" justifyContent="flex-end">

                    <Grid align="center" item xs={12} ms={12} lg={12} style={{ minHeight: "200px" }}>

                        <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ marginTop: "10px", padding: "4px" }}>
                            {props.membershipPackage.PackageName + ' - ' + PackageDiscriptionHeading}
                        </Typography>

                        <Grid item xs={12} style={{ border: "0.5px solid silver" }}>
                            <Typography variant="subtitle2" color="textSecondary" style={{ padding: "20px" }} align="justify">
                                {ReactHtmlParser(GetMembershipPackageDis(props.membershipPackage.Description))}
                            </Typography>

                            <Link
                                component="button"
                                variant="body2"
                                onClick={ShowMoreInfoClick}
                                style={{ display: props.membershipPackage.Description && props.membershipPackage.Description.length < DisplayMemPackageDiscriptionCharacters ? 'none' : 'block' }}
                            >
                                {readmorebtnText}
                            </Link>
                        </Grid>
                    </Grid>

                </Grid>

                <Grid container item lg={12} sm={12} xs={12} justifyContent="flex-end">

                    <Grid item lg={12} sm={12} xs={12} style={{ marginBottom: "10px" }}>

                        <Hidden smDown>
                            <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ marginTop: "10px", padding: "4px" }}>
                                Membership Types
                            </Typography>
                        </Hidden>

                        <Hidden xsDown mdUp>
                            <Typography className={classes.smalltourheaderbox} align="center" variant="h3" style={{ marginTop: "10px", padding: "4px" }}>
                                Membership Types
                            </Typography>
                        </Hidden>

                        <Hidden smUp>
                            <Typography className={classes.smalltourheaderbox} align="center" variant="h3" style={{ marginTop: "10px", padding: "4px" }}>
                                Membership Types
                            </Typography>
                        </Hidden>
                    </Grid>

                    {props.membershipPackage.hasOwnProperty("MembershipProducts") && props.membershipPackage.MembershipProducts.map((membershipProduct, i) => {

                        return membershipProduct.MembershipType === "Membership" ?

                            <Grid container style={{ marginTop: '10px' }} key={i}>
                                <Grid lg={8} sm={8} xs={8} style={{ marginTop: '5px' }}>

                                    <Hidden smDown>
                                        <Typography variant="h3">{replaceEscapeCharacters(membershipProduct.ProductName)} </Typography>
                                        <Typography className={membershipProduct.hasOwnProperty('Users') && (membershipProduct.Users === undefined ? 0 : membershipProduct.Users.length) < membershipProduct.MinQuantity || (membershipProduct.Users === undefined ? 0 : membershipProduct.Users.length) > membershipProduct.MaxQuantity ? classes.errorColor : classes.defaultColor} style={{ marginTop: "3px", marginLeft: "5px" }}> {membershipProduct.AgeBasedMembership ? '(Min Age : ' + membershipProduct.MinAge + ', Max Age : ' + membershipProduct.MaxAge + ')' : ''} {GetMembershipTypeQty(props.membershipPackage, membershipProduct)}
                                        </Typography>
                                    </Hidden>

                                    <Hidden xsDown mdUp>
                                        <Typography variant="h4">{replaceEscapeCharacters(membershipProduct.ProductName)}</Typography>
                                        <Typography className={membershipProduct.hasOwnProperty('Users') && (membershipProduct.Users === undefined ? 0 : membershipProduct.Users.length) < membershipProduct.MinQuantity || (membershipProduct.Users === undefined ? 0 : membershipProduct.Users.length) > membershipProduct.MaxQuantity ? classes.errorColor : classes.defaultColor} variant="h6" style={{ marginTop: "3px", marginLeft: "5px" }}> {membershipProduct.AgeBasedMembership ? '(Min Age : ' + membershipProduct.MinAge + ', Max Age : ' + membershipProduct.MaxAge + ')' : ''} {GetMembershipTypeQty(props.membershipPackage, membershipProduct)}
                                        </Typography>
                                    </Hidden>

                                    <Hidden smUp>
                                        <Typography variant="h5">{replaceEscapeCharacters(membershipProduct.ProductName)}</Typography>
                                        <Typography className={membershipProduct.hasOwnProperty('Users') && (membershipProduct.Users === undefined ? 0 : membershipProduct.Users.length) < membershipProduct.MinQuantity || (membershipProduct.Users === undefined ? 0 : membershipProduct.Users.length) > membershipProduct.MaxQuantity ? classes.errorColor : classes.defaultColor} variant="h6" style={{ marginTop: "3px", marginLeft: "5px" }}> {membershipProduct.AgeBasedMembership ? '(Min Age : ' + membershipProduct.MinAge + ', Max Age : ' + membershipProduct.MaxAge + ')' : ''} {GetMembershipTypeQty(props.membershipPackage, membershipProduct)}
                                        </Typography>
                                    </Hidden>


                                </Grid>
                                <Grid item lg={4} sm={4} xs={4} align="right">

                                    <Hidden smDown>
                                        <Typography variant="h4"> {genfunction.ccyFormat(membershipProduct.Price)}</Typography>
                                    </Hidden>

                                    <Hidden xsDown mdUp>
                                        <Typography variant="h5"> {genfunction.ccyFormat(membershipProduct.Price)}</Typography>
                                    </Hidden>

                                    <Hidden smUp>
                                        <Typography variant="h6"> {genfunction.ccyFormat(membershipProduct.Price)}</Typography>
                                    </Hidden>
                                </Grid>
                                <Grid xs={12} className={classes.hr} style={{ marginTop: '5px' }}>
                                </Grid>

                                <Grid item lg={12} sm={12} xs={12} style={{ minHeight: '100px' }}>
                                    {membershipProduct.Users && membershipProduct.Users.length > 0
                                        ? membershipProduct.Users.sort((a, b) => Number(b.isPrimaryMember) - Number(a.isPrimaryMember)).map((membership, i) => {
                                            return (
                                                <div key={i}>
                                                    <Grid item lg={12} sm={12} xs={12} container style={{ marginTop: "10px" }}>
                                                        <>
                                                            <Tooltip
                                                                enterDelay={300}
                                                                title="Edit"
                                                                enterTouchDelay={0} 
                                                                leaveTouchDelay={1000}
                                                            >
                                                                <EditIcon
                                                                    className={classes.AddHoverOnIcons}
                                                                    color={"primary"}
                                                                    onClick={() => { EditPerson(membership, membershipProduct.MembershipTypeID) }}
                                                                />
                                                            </Tooltip>
                                                            {membership.isPrimaryMember && membership.isRenewal ? '' :
                                                                <Tooltip
                                                                    enterDelay={300}
                                                                    title="Delete"
                                                                    enterTouchDelay={0} 
                                                                    leaveTouchDelay={1000}
                                                                >
                                                                    <CancelIcon
                                                                        className={classes.AddHoverOnIcons}
                                                                        onClick={() => { DeletePerson(membershipProduct.MembershipTypeID, membership) }}
                                                                        color={"error"}
                                                                    />
                                                                </Tooltip>}
                                                        </>

                                                        <Typography className={classes.UserNameDisplay}>{membership.firstName}  {membership.lastName}</Typography>
                                                    </Grid>

                                                    <Grid item lg={12} sm={12} xs={12} container style={{ marginTop: "10px" }}>

                                                        {(membershipProduct.Users === undefined ? 0 : membershipProduct.Users.length) < membershipProduct.MinQuantity ?
                                                            <>

                                                                <Tooltip
                                                                    enterDelay={300}
                                                                    title="Add"
                                                                    enterTouchDelay={0}
                                                                     leaveTouchDelay={1000}
                                                                >
                                                                    <PersonAddIcon
                                                                        className={classes.AddHoverOnIcons}
                                                                        onClick={() => handleClickOpen(membershipProduct.MembershipTypeID, replaceEscapeCharacters(membershipProduct.ProductName))}
                                                                        color={"primary"}

                                                                    />
                                                                </Tooltip>

                                                                <Typography className={classes.errorColor + ' ' + classes.NoPersonAssignedTxt} >{ValidateMembershipMinQuantity}</Typography>

                                                            </> : ''
                                                        }

                                                    </Grid>
                                                </div>
                                            )
                                        })

                                        :


                                        <Grid item lg={12} sm={12} xs={12} container style={{ marginTop: "10px" }}>

                                            {(membershipProduct.Users === undefined ? 0 : membershipProduct.Users.length) < membershipProduct.MinQuantity ?
                                                <>

                                                    <Tooltip
                                                        enterDelay={300}
                                                        title="Add"
                                                        enterTouchDelay={0}
                                                         leaveTouchDelay={1000}
                                                    >
                                                        <PersonAddIcon
                                                            className={classes.AddHoverOnIcons}
                                                            onClick={() => handleClickOpen(membershipProduct.MembershipTypeID, replaceEscapeCharacters(membershipProduct.ProductName))}
                                                            color={"primary"}
                                                        />
                                                    </Tooltip>

                                                    <Typography className={classes.errorColor + ' ' + classes.NoPersonAssignedTxt} >{ValidateMembershipMinQuantity}</Typography>

                                                </> : ''
                                            }

                                            {(membershipProduct.Users ? membershipProduct.Users.length : 0) <= membershipProduct.MaxQuantity && (membershipProduct.Users ? membershipProduct.Users.length : 0) >= membershipProduct.MinQuantity ?
                                                <>

                                                    <Tooltip
                                                        enterDelay={300}
                                                        title="Add"
                                                        enterTouchDelay={0} 
                                                        leaveTouchDelay={1000}
                                                    >
                                                        <PersonAddIcon
                                                            className={classes.AddHoverOnIcons}
                                                            onClick={() => handleClickOpen(membershipProduct.MembershipTypeID, replaceEscapeCharacters(membershipProduct.ProductName))}
                                                            color={"primary"}
                                                        />
                                                    </Tooltip>

                                                    <Typography className={classes.NoPersonAssignedTxt}>No person is currently assigned to this type.</Typography>

                                                </> : ''
                                            }
                                        </Grid>

                                    }

                                    {membershipProduct.hasOwnProperty('Users') && membershipProduct.Users.length > membershipProduct.MaxQuantity ?
                                        <Grid item lg={12} sm={12} xs={12} container style={{ marginTop: "10px" }}>

                                            <Hidden smDown>
                                                <Typography className={classes.errorColor} style={{ fontSize: "16px", marginLeft: "50px", marginTop: "10px" }}>{ValidateMembershipMaxQuantity}</Typography>

                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                <Typography className={classes.errorColor} style={{ fontSize: "14px", marginTop: "10px" }}>{ValidateMembershipMaxQuantity}</Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography className={classes.errorColor} style={{ fontSize: "12px", marginTop: "10px" }}>{ValidateMembershipMaxQuantity}</Typography>
                                            </Hidden>
                                        </Grid>
                                        :
                                        ''
                                    }

                                    {membershipProduct.hasOwnProperty('Users') && membershipProduct.Users.length > 0 ?
                                        <Grid item lg={12} sm={12} xs={12} container style={{ marginTop: "10px" }}>
                                            <Tooltip
                                                enterDelay={300}
                                                title="Add"
                                                enterTouchDelay={0} 
                                                leaveTouchDelay={1000}
                                            >
                                                <PersonAddIcon
                                                    className={classes.AddHoverOnIcons}
                                                    onClick={() => handleClickOpen(membershipProduct.MembershipTypeID, replaceEscapeCharacters(membershipProduct.ProductName))}
                                                    color={membershipProduct.Users.length >= membershipProduct.MaxQuantity ? "disabled" : "primary"}
                                                    style={{ pointerEvents: (membershipProduct.Users.length >= membershipProduct.MaxQuantity ? 'None' : '') }}
                                                />
                                            </Tooltip>
                                        </Grid>
                                        :
                                        ''
                                    }

                                </Grid>
                            </Grid>

                            : null
                    })}

                    {props.membershipPackage.hasOwnProperty("MembershipProducts") &&
                        props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "AddOn").length > 0 ?
                        <>
                            <Grid item lg={12} sm={12} xs={12}>

                                <Hidden smDown>
                                    <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ marginTop: "20px", padding: "4px" }}>
                                        {MembershipAddOnsHeading}
                                    </Typography>
                                </Hidden>

                                <Hidden xsDown mdUp>
                                    <Typography className={classes.smalltourheaderbox} align="center" variant="h3" style={{ marginTop: "20px", padding: "4px" }}>
                                        {MembershipAddOnsHeading}
                                    </Typography>
                                </Hidden>

                                <Hidden smUp>
                                    <Typography className={classes.smalltourheaderbox} align="center" variant="h4" style={{ marginTop: "20px", padding: "4px" }}>
                                        {MembershipAddOnsHeading}
                                    </Typography>
                                </Hidden>

                            </Grid>
                            <Grid container item lg={12} sm={12} xs={12} className={classes.hr}>
                            </Grid></>
                        : null}

                    {props.membershipPackage.hasOwnProperty("MembershipProducts") && props.membershipPackage.MembershipProducts.map((addonMembership, i) => {

                        return addonMembership.MembershipType === "AddOn" ?
                            <Grid container lg={12} sm={12} xs={12} style={{ marginTop: "10px" }} key={i}>
                                <Grid container item lg={6} sm={6} xs={6} >

                                    <Hidden smDown>
                                        <Typography variant="h3" style={{ marginTop: "10px" }}>{replaceEscapeCharacters(addonMembership.ProductName)} </Typography>
                                    </Hidden>

                                    <Hidden xsDown mdUp>
                                        <Typography variant="h4" style={{ marginTop: "10px" }}>{replaceEscapeCharacters(addonMembership.ProductName)} </Typography>
                                    </Hidden>

                                    <Hidden smUp>
                                        <Typography variant="h5" style={{ marginTop: "10px" }}>{replaceEscapeCharacters(addonMembership.ProductName)} </Typography>
                                    </Hidden>

                                </Grid>
                                <Grid item lg={3} sm={3} xs={3} align="left" >
                                    {(addonMembership.Quantity > 0 || addonMembership.MinQuantity > 0) ? () => changeQuantityHandler(addonMembership) : ''}
                                    <Checkbox
                                        color="primary"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        onChange={() => changeQuantityHandler(addonMembership)}
                                        checked={(addonMembership.Quantity > 0 || addonMembership.MinQuantity > 0)}
                                    />
                                </Grid>

                                <Grid item lg={3} sm={3} xs={3} align="right" style={{ marginTop: "10px" }}>
                                    <Hidden smDown>
                                        <Typography variant="h4"> {genfunction.ccyFormat(addonMembership.Price)}</Typography>
                                    </Hidden>

                                    <Hidden xsDown mdUp>
                                        <Typography variant="h5"> {genfunction.ccyFormat(addonMembership.Price)}</Typography>
                                    </Hidden>

                                    <Hidden smUp>
                                        <Typography variant="h6"> {genfunction.ccyFormat(addonMembership.Price)}</Typography>
                                    </Hidden>
                                </Grid>
                            </Grid>

                            : null
                    })}

                    <Grid container xs={12}>
                        <Grid item lg={12} sm={12} xs={12} align="right">
                            <Grid style={{ padding: "30px 0px 30px 0px" }}>

                                <Hidden smDown>
                                    <Typography variant="h4">Tax = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TaxTotal)}</Typography>
                                    <Typography variant="h4">Total = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TotalAmount)}</Typography>
                                </Hidden>

                                <Hidden xsDown mdUp>
                                    <Typography variant="h5">Tax = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TaxTotal)}</Typography>
                                    <Typography variant="h5">Total = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TotalAmount)}</Typography>
                                </Hidden>

                                <Hidden smUp>
                                    <Typography variant="h6">Tax = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TaxTotal)}</Typography>
                                    <Typography variant="h">Total = {genfunction.ccyFormat(genfunction.CalculateMembershipPackageTotal(memberPackage).TotalAmount)}</Typography>
                                </Hidden>

                            </Grid>

                            <Grid item style={{ padding: "30px 0px 30px 0px" }}>

                                <Hidden smDown>
                                    <Button variant="contained" onClick={() => constredirect()} size="large" className={classes.primarycolor}
                                        style={{ marginRight: "10px", marginTop: 0 }}>
                                        Cancel
                                    </Button>
                                    <Button variant="contained"
                                        onClick={() => ConfirmMembershipPackage()} disabled={ValidateMemberPackageQuantities()}
                                        className={classes.primarycolor}
                                        style={{ marginTop: 0 }}
                                        size="large" >
                                        Add to Cart
                                    </Button>
                                </Hidden>

                                <Hidden xsDown mdUp>
                                    <Button variant="contained" onClick={() => constredirect()} size="large" className={classes.primarycolor}
                                        style={{ marginRight: "10px", marginTop: 10 }}>
                                        Cancel
                                    </Button>
                                    <Button variant="contained"
                                        onClick={() => ConfirmMembershipPackage()} disabled={ValidateMemberPackageQuantities()}
                                        className={classes.primarycolor}
                                        style={{ marginTop: 10 }}
                                        size="large" >
                                        Add to Cart
                                    </Button>
                                </Hidden>

                                <Hidden smUp>
                                    <Button variant="contained" onClick={() => constredirect()} size="medium" className={classes.primarycolor}
                                        style={{ marginRight: "10px", marginTop: 10 }}>
                                        Cancel
                                    </Button>
                                    <Button variant="contained"
                                        onClick={() => ConfirmMembershipPackage()} disabled={ValidateMemberPackageQuantities()}
                                        className={classes.primarycolor}
                                        style={{ marginTop: 10 }}
                                        size="medium" >
                                        Add to Cart
                                    </Button>
                                </Hidden>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item lg={1} xs={12} align="center">
                    <Divider orientation="vertical" flexItem style={{ border: "0.5px solid silver", marginTop: "20px", marginBottom: "-30px" }} />
                </Grid>
            </Grid>

            {/* Add/Edit Person Dialog Start */}

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >

                <DialogTitle id="form-dialog-title" className={classes.dialogTitleHeader} >
                    <Typography className="AddPersonMembershipTitle">
                        {state.memberpackageDetail.popupTitle}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers={true}>


                    <form className={classes.root + " addmembership webkitScroll"}
                        noValidate autoComplete="off"
                    >
                        <Grid container xs={12} spacing={1}>

                            {props.isRenewPackage && state.memberpackageDetail.isEdit && state.memberpackageDetail.PreviousMembershipType !== undefined ?
                                <>
                                    <Grid item xs={6} >
                                        <Typography variant="subtitle1" color="textSecondary">Current Membership Type : </Typography>
                                    </Grid>
                                    <Grid item xs={6} >
                                        <Typography variant="subtitle1" color="textSecondary"> {state.memberpackageDetail.PreviousMembershipType}</Typography>
                                    </Grid>

                                    <Grid item xs={6} >
                                        <Typography variant="subtitle1" color="textSecondary">Expiry Date :  </Typography>
                                    </Grid>
                                    <Grid item xs={6} >
                                        <Typography variant="subtitle1" color="textSecondary"> {Moment(state.memberpackageDetail.MembershipExpiryDate).format('YYYY-MM-DD')}</Typography>
                                    </Grid>
                                </>

                                : null}

                            <Grid item xs={6}>
                                <Typography variant="subtitle1" color="textSecondary">Membership Type</Typography>
                            </Grid>
                            <Grid item xs={6} >
                                <FormControl style={{ width: "100%" }} error={errorstate.initialerrorstate.membershipType.errorstate}>
                                    <Select
                                        labelId="Membership Type"
                                        id="membershipType"
                                        name="membershipType"
                                        displayEmpty
                                        value={GetDefaultMembershipName(state.memberpackageDetail.membershipTypeName)}
                                        onChange={fieldhandleChange}
                                        fullWidth={true}
                                    >

                                        {props.membershipPackage.hasOwnProperty("MembershipProducts") &&
                                            props.membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").map((membershipProduct, i) =>
                                            (
                                                state.memberpackageDetail.isEdit === false ?
                                                    (membershipProduct.Users !== undefined && membershipProduct.Users.length) < membershipProduct.MaxQuantity ?
                                                        <MenuItem
                                                            key={i}
                                                            id={membershipProduct.MembershipTypeID}
                                                            value={replaceEscapeCharacters(membershipProduct.ProductName)}>
                                                            {replaceEscapeCharacters(membershipProduct.ProductName)}
                                                        </MenuItem>
                                                        : null
                                                    :
                                                    <MenuItem
                                                        key={i}
                                                        id={membershipProduct.MembershipTypeID}
                                                        value={replaceEscapeCharacters(membershipProduct.ProductName)}>
                                                        {replaceEscapeCharacters(membershipProduct.ProductName)}
                                                    </MenuItem>
                                            ))}
                                    </Select>
                                    <FormHelperText>{errorstate.initialerrorstate.membershipType.errortext}</FormHelperText>
                                </FormControl>
                            </Grid>

                            {props.isRenewPackage === true && state.memberpackageDetail.isEdit === false ?
                                <>
                                    <Grid item xs={6}>
                                        <Typography variant="subtitle1" color="textSecondary">Select Existing Member Profile</Typography>
                                    </Grid>
                                    <Grid item xs={6} >
                                        <FormControl style={{ width: "100%" }} >
                                            <Select
                                                labelId="Search Existing Member Profile"
                                                id="searchExistingMemberProfile"
                                                name="searchExistingMemberProfile"
                                                displayEmpty
                                                value={GetDefaultMemberName(state.memberpackageDetail.userNo)}
                                                onChange={fieldhandleChange}
                                                fullWidth={true}
                                                disabled={(usersnotpartofpackage
                                                    && usersnotpartofpackage.length > 0
                                                    && usersnotpartofpackage.filter(x => x.notpartofPackage == true && x.userSelectedFromDropdown == false).length === 0)}
                                            >

                                                {usersnotpartofpackage
                                                    && usersnotpartofpackage.length > 0
                                                    && usersnotpartofpackage.filter(x => x.notpartofPackage == true && x.userSelectedFromDropdown == false).length > 0
                                                    && usersnotpartofpackage.filter(x => x.notpartofPackage == true && x.userSelectedFromDropdown == false).map((child, i) =>
                                                    (
                                                        <MenuItem
                                                            key={i}
                                                            id={child.userNo}
                                                            value={child.firstName + ' ' + child.lastName}
                                                            data-userID={child.userNo}
                                                            disabled={(usersnotpartofpackage
                                                                && usersnotpartofpackage.length > 0
                                                                && usersnotpartofpackage.filter(x => x.notpartofPackage == true && x.userSelectedFromDropdown == false).length === 0)}
                                                        >
                                                            {child.firstName + ' ' + child.lastName}
                                                        </MenuItem>
                                                    )
                                                    )
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}></Grid>
                                    <Grid item xs={6} style={{ marginTop: '10px' }}>
                                        <Typography>OR</Typography>
                                    </Grid>

                                    <Grid item xs={6}></Grid>
                                    <Grid item xs={6} style={{ marginTop: '10px' }}>
                                        <Button className={classes.primarycolor} variant="contained" size="medium"
                                            disabled={createNewProfile}
                                            onClick={() => {
                                                setCreateNewProfile(true);
                                                handleClickOpen(state.memberpackageDetail.membershipTypeID, replaceEscapeCharacters(state.memberpackageDetail.membershipTypeName));
                                            }}
                                        >
                                            Create New Profile
                                        </Button>
                                    </Grid>
                                </>
                                : ''}


                            <>
                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        autoFocus
                                        onChange={fieldhandleChange}
                                        name="fname"
                                        id="fname"
                                        label="First Name"
                                        fullWidth={true}
                                        error={errorstate.initialerrorstate.first_name.errorstate}
                                        helperText={errorstate.initialerrorstate.first_name.errortext}
                                        value={state.memberpackageDetail.firstName}
                                        inputProps={{ maxLength: AddPersonFirstNameLength }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        onChange={fieldhandleChange}
                                        id="lname"
                                        name="lname"
                                        label="Last Name"
                                        error={errorstate.initialerrorstate.last_name.errorstate}
                                        helperText={errorstate.initialerrorstate.last_name.errortext}
                                        value={state.memberpackageDetail.lastName}
                                        fullWidth={true}
                                        inputProps={{ maxLength: AddPersonLastNameLength }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        margin="dense"
                                        onChange={fieldhandleChange}
                                        id="email"
                                        name="email"
                                        label={state.memberpackageDetail.isPrimaryMember ? 'Email' : 'Email (Optional)'}
                                        type="email"
                                        fullWidth={true}
                                        value={state.memberpackageDetail.email}
                                        error={errorstate.initialerrorstate.email.errorstate}
                                        helperText={errorstate.initialerrorstate.email.errortext}
                                        inputProps={{ maxLength: AddPersonEmailLength }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        margin="dense"
                                        type="date"
                                        name="dob"
                                        id="dob"
                                        InputLabelProps={{ shrink: true }}
                                        label="DOB (Optional)"
                                        value={state.memberpackageDetail.dob}
                                        defaultValue=""
                                        onChange={fieldhandleChange}
                                        error={errorstate.initialerrorstate.age.errorstate}
                                        helperText={errorstate.initialerrorstate.age.errortext}
                                        fullWidth={true}
                                        inputProps={{ maxLength: AddPersonDOBLength }}
                                        onInput={(e) => onChangeInput(e)}
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <TextField
                                        margin="dense"
                                        id="phone"
                                        name="phone"
                                        label={PhoneNumberMandatory ? "Phone #" : "Phone # (Optional)"}
                                        type="text"
                                        fullWidth={true}
                                        onChange={fieldhandleChange}
                                        value={state.memberpackageDetail.phone}
                                        error={errorstate.initialerrorstate.phone.errorstate}
                                        helperText={errorstate.initialerrorstate.phone.errortext}
                                        InputProps={{
                                            inputComponent: TextMaskCustom
                                        }}
                                    />
                                </Grid>
                            </>

                            <Grid item xs={12}>

                                {genfunction.IsObjectNotNullOrEmptyOrUndefined(countryandstates) ?

                                    <FormControl className={classes.box100per} error={errorstate.initialerrorstate.country.errorstate}>

                                        <Autocomplete filterOptions={filterOptions}
                                            id="country"
                                            name="country"
                                            className={displayclass}
                                            options={countryandstates}
                                            fullWidth={true}
                                            onChange={onChangeCountry}
                                            autoHighlight
                                            getOptionLabel={(option) => {
                                                if (option.hasOwnProperty('Country')) {
                                                    return option.Country;
                                                }
                                                return option;
                                            }}
                                            value={state.memberpackageDetail.country}
                                            // defaultValue={countryandstates[0]}
                                            renderOption={(option) => (
                                                <>
                                                    <img
                                                        loading="lazy"
                                                        width="40"
                                                        src={`https://flagcdn.com/w40/${option.ISOCode}.png`}
                                                        srcSet={`https://flagcdn.com/w80/${option.ISOCode}.png 2x`}
                                                        alt=""
                                                        style={{ margin: "10px" }}
                                                    />
                                                    {` ${option.Country} `}</>
                                            )}

                                            style={{ width: "100%" }}
                                            renderInput={(params) =>
                                            (<TextField label="Country" variant='outlined' className={classes.clearButton}{...params}
                                            />
                                            )}

                                        />
                                        <FormHelperText>{errorstate.initialerrorstate.country.errortext}</FormHelperText>
                                    </FormControl>
                                    : ""}

                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="address1"
                                    name="address1"
                                    label="Address 1"
                                    type="text"
                                    onChange={fieldhandleChange}
                                    fullWidth={true}
                                    value={state.memberpackageDetail.address1}
                                    className={displayclass}
                                    error={errorstate.initialerrorstate.address1.errorstate}
                                    helperText={errorstate.initialerrorstate.address1.errortext}
                                    inputProps={{ maxLength: AddPersonAddress1Length }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="address2"
                                    name="address2"
                                    label="Address 2 (Optional)"
                                    type="text"
                                    fullWidth={true}
                                    onChange={fieldhandleChange}
                                    value={state.memberpackageDetail.address2}
                                    className={displayclass}
                                    inputProps={{ maxLength: AddPersonAddress2Length }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    fullWidth={true}
                                    id="city"
                                    name="city"
                                    label={isShowCountryFields("CityText")}
                                    type="text"
                                    onChange={fieldhandleChange}
                                    value={state.memberpackageDetail.city}
                                    className={displayclass}
                                    error={errorstate.initialerrorstate.city.errorstate}
                                    helperText={errorstate.initialerrorstate.city.errortext}
                                    inputProps={{ maxLength: AddPersonCityLength }}
                                />
                            </Grid>

                            <Grid item xs={6} md={isShowCountryFields("ShowPostalCode") ? 6 : 12}>
                                {genfunction.IsObjectNotNullOrEmptyOrUndefined(countryandstates) && isShowCountryFields("ShowState") ?

                                    <FormControl className={classes.box100per} error={errorstate.initialerrorstate.state.errorstate}>

                                        <Autocomplete filterOptions={filterOptions}
                                            id="state"
                                            name="state"
                                            className={displayclass}
                                            autoHighlight
                                            options={
                                                state.memberpackageDetail.country ? countryandstates.filter(
                                                    x => x.Country == state.memberpackageDetail.country).map(o => o.hasOwnProperty("Picklist") ? o.Picklist : [])[0]
                                                    : []
                                            }
                                            fullWidth={true}
                                            onChange={onChangeState}
                                            getOptionLabel={(option) => {
                                                if (option.hasOwnProperty('State')) {
                                                    return option.State;
                                                }
                                                return option;
                                            }}
                                            value={state.memberpackageDetail.state}
                                            style={{ width: "100%" }}
                                            renderInput={(params) =>
                                            (<TextField label="State" variant='outlined' className={classes.clearButton}{...params}
                                            />
                                            )}

                                        />
                                        <FormHelperText>{errorstate.initialerrorstate.state.errortext}</FormHelperText>
                                    </FormControl>
                                    : ""}
                            </Grid>

                            <Grid item xs={6} md={isShowCountryFields("ShowState") ? 6 : 12}>

                                {isShowCountryFields("ShowPostalCode") ?
                                    <TextField
                                        fullWidth={true}
                                        id="zipcode"
                                        name="zipcode"
                                        label={isShowCountryFields("PostalCodeName")}
                                        type="text"
                                        onChange={fieldhandleChange}
                                        value={state.memberpackageDetail.zipcode}
                                        className={displayclass}
                                        error={errorstate.initialerrorstate.zipcode.errorstate}
                                        helperText={errorstate.initialerrorstate.zipcode.errortext}
                                        inputProps={{ maxLength: AddPersonZipCodeLength }}
                                    />
                                    : ""}
                            </Grid>
                        </Grid>

                    </form>

                    {/* Membership UDFs */}
                    <Grid container xs={12} style={{ marginTop: (props.isRenewPackage === true ? '-10px' : '20px') }}>
                        <Grid item lg={12} sm={12} xs={12}>
                            {state.memberpackageDetail.membershipTypeID && state.memberpackageDetail.membershipTypeID > 0
                                && props.membershipPackage.hasOwnProperty("MembershipProducts") ? props.membershipPackage.MembershipProducts.map((membershipProduct) => {

                                    return membershipProduct.MembershipTypeID && membershipProduct.MembershipTypeID === state.memberpackageDetail.membershipTypeID ?
                                        <div key={membershipProduct.MembershipTypeID + "_" + state.memberpackageDetail.userNo}>
                                            <Grid item lg={12} sm={12} xs={12} spacing={1} >
                                                <MembershipUDF MembershipTypeID={membershipProduct.MembershipTypeID} userNo={state.memberpackageDetail.userNo} isEdit={state.memberpackageDetail.isEdit} />
                                            </Grid>
                                        </div>
                                        : null
                                })
                                : null
                            }
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions style={{ marginRight: "50px", marginBottom: "3px" }}>
                    <Button disabled={!ValidateMembershipType() && state.memberpackageDetail.isEdit} className={classes.primarycolor} variant="contained" size="medium" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className={classes.primarycolor} disabled={saveBtn} variant="contained" onClick={() => saveDialog()} size="medium" >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Add/Edit Person Dialog End */}


            {/* Confirmation Box Start*/}
            <DialogeBox open={confirmopen.dialogBox} title="Delete Person"
                message={confirmopen.deletemsg}
                button1text="Cancel"
                button1clickhandler={CancelPersonDelete}
                button2text="Yes"
                button2clickhandler={ConfirmDeletePerson}
            ></DialogeBox>
            {/* Confirmation Box Start*/}

        </Container >
    );
};
